var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoLogsVid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.798,
    height: 17.825,
    viewBox: "0 0 29.798 17.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1600.539-2250.035l-4.814,3.178a4.042,4.042,0,0,0-3.985-3.367h-14.355a4.042,4.042,0,0,0-4.042,4.042v9.663a4.042,4.042,0,0,0,4.042,4.042h14.355a4.041,4.041,0,0,0,4.038-3.881l4.761,3.143a1.748,1.748,0,0,0,2.6-1.72v-13.379A1.747,1.747,0,0,0-1600.539-2250.035Z",
    transform: "translate(1627.734 2250.304)",
    fill: "#734bd1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLogsVid);
export default __webpack_public_path__ + "static/media/video_logs_vid.51ef67285a8d4dd7fc9691b67bb6eb53.svg";
export { ForwardRef as ReactComponent };